import { render, staticRenderFns } from "./QuoteHeader.vue?vue&type=template&id=34979168&scoped=true"
import script from "./QuoteHeader.vue?vue&type=script&lang=js"
export * from "./QuoteHeader.vue?vue&type=script&lang=js"
import style0 from "./QuoteHeader.vue?vue&type=style&index=0&id=34979168&lang=scss&scoped=true"
import style1 from "./QuoteHeader.vue?vue&type=style&index=1&id=34979168&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34979168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34979168')) {
      api.createRecord('34979168', component.options)
    } else {
      api.reload('34979168', component.options)
    }
    module.hot.accept("./QuoteHeader.vue?vue&type=template&id=34979168&scoped=true", function () {
      api.rerender('34979168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteHeader.vue"
export default component.exports